import { PaginationInfo } from "./loan.model";

export interface getNoticesResponse {
  isPinned?: boolean;
  noticeKey: string;
  noticeType: string;
  noticeTypePersian: string;
  creationDate: Date;
  creationDatePersian: string;
  showInLoginPage?: boolean;
  title: string;
  body: string;
  attachments?: Attachments[];
  expirationDate: Date;
  canSendSms?: boolean;
  rawBody?: string;
  attachmentCount: number;
  viewDate: Date;
}

export interface Attachments {
  id: number;
  fileId: string;
  fileName: string;
  documentType: string;
  documentTypeTitle: string;
  fileType: string;
  fileUrl: string;
}

export class getAllSupplierNoticesRequest {
  paginationInfo: PaginationInfo | undefined;
  filter: Filter | undefined;
}
export class Filter {
  noticeType: string | undefined;
  title: string | undefined;
}
export class noticeDetailRequest {
  noticeKey: string | undefined;
}
export class updateSupplierNoticePinRequest {
  noticeKey: string | undefined;
  isPinned: boolean | undefined;
}

export interface noticeSummaryResponse {
  count: number;
  hasInstant: boolean;
}

export interface getSelectResponse {
  id: number | undefined;
  title: string | undefined;
  enumData: string | undefined;
  maxSize_KB?: number | undefined;
}
